import { render, staticRenderFns } from "./edit-file-settings.vue?vue&type=template&id=a9f4e752"
import script from "./edit-file-settings.vue?vue&type=script&lang=js"
export * from "./edit-file-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9f4e752')) {
      api.createRecord('a9f4e752', component.options)
    } else {
      api.reload('a9f4e752', component.options)
    }
    module.hot.accept("./edit-file-settings.vue?vue&type=template&id=a9f4e752", function () {
      api.rerender('a9f4e752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/EDI/edit-file-settings.vue"
export default component.exports